import { AfterContentInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from '../service/auth.service';
import { base_host, environment, my_port, my_protocol } from 'src/environments/environment';


@Component({
  selector: 'app-admin-company-pricing',
  templateUrl: './admin-company-pricing.component.html',
  styleUrls: ['./admin-company-pricing.component.css']
})
export class AdminCompanyPricingComponent implements OnInit {


  companies = [];
  company;
  errMessage = "";
  successMessage = "";
  routeID:string = this.route.snapshot.params.id;
  businessID: string = this.route.snapshot.params.businessID;
  authToken = localStorage.getItem('auth');
  users = [];
  pathUrl;
  order;
  isAverageCert = false;
  isNPSCert = false;
  subGroups = [];
  pricing;
  isLoading = false;


  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}`  }),
    withCredentials: true,
  };


  constructor(
    private router: Router,
    private http: HttpClient,
    private route:ActivatedRoute,
    private authService: AuthService) {

     }

  ngOnInit(): void {
    this.fetchPricingDetails();
  }

  fetchPricingDetails() {
    this.http.get(environment.ADMIN_COMPANY_PRICING + '/' +this.routeID, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {
          this.pricing = res.message;

          setTimeout(() => {
            (<HTMLInputElement>document.getElementById('vat')).value = this.pricing.vat;
            (<HTMLInputElement>document.getElementById('grounding_fee')).value = this.pricing.grounding_fee;
            (<HTMLInputElement>document.getElementById('monthly_fee')).value = this.pricing.monthly_fee;
            (<HTMLInputElement>document.getElementById('per_user_monthly_fee')).value = this.pricing.per_user_monthly_fee;
            (<HTMLInputElement>document.getElementById('per_subgroup_monthly_fee')).value = this.pricing.per_subgroup_monthly_fee;
            (<HTMLInputElement>document.getElementById('feed_feed_publish')).value = this.pricing.feed.feed_publish;
            (<HTMLInputElement>document.getElementById('feed_feed_ad')).value = this.pricing.feed.ads.price;
            (<HTMLInputElement>document.getElementById('market_place_leave')).value = this.pricing.marketplace.leave.price;
            (<HTMLInputElement>document.getElementById('market_place_bid')).value = this.pricing.marketplace.bid.price;
            (<HTMLInputElement>document.getElementById('headhunting_profile_opening_days_valid')).value = this.pricing.headhunting_profile_opening.days_valid;
            (<HTMLInputElement>document.getElementById('headhunting_profile_opening')).value = this.pricing.headhunting_profile_opening.price;
            (<HTMLInputElement>document.getElementById('wishlist_profile_days_valid')).value = this.pricing.wishlist_profile_opening.days_valid;
            (<HTMLInputElement>document.getElementById('wishlist_profile_opening')).value = this.pricing.wishlist_profile_opening.price;
            (<HTMLInputElement>document.getElementById('application_profile_days_valid')).value = this.pricing.application_profile_opening.days_valid;
            (<HTMLInputElement>document.getElementById('application_profile_opening')).value = this.pricing.application_profile_opening.price;
          },300)



          console.log(this.pricing);

        }
        else {
          var anElm = document.getElementById('notadded');
          anElm.style.display="block";
          console.log('ei ole kyseistä käyttäjää')
        }
        
      }, (err: any) => {
  
        console.log("Error while finding status :: ", err);
      })
  }

  saveChanges() {

    this.isLoading = true;

    //Check if any of the inputs are empty

    if((<HTMLInputElement>document.getElementById('vat')).value == "" || (<HTMLInputElement>document.getElementById('grounding_fee')).value == "" || (<HTMLInputElement>document.getElementById('monthly_fee')).value == "" || (<HTMLInputElement>document.getElementById('per_user_monthly_fee')).value == "" || (<HTMLInputElement>document.getElementById('per_subgroup_monthly_fee')).value == "" || (<HTMLInputElement>document.getElementById('feed_feed_publish')).value == "" || (<HTMLInputElement>document.getElementById('feed_feed_ad')).value == "" || (<HTMLInputElement>document.getElementById('market_place_leave')).value == "" || (<HTMLInputElement>document.getElementById('market_place_bid')).value == "" || (<HTMLInputElement>document.getElementById('headhunting_profile_opening_days_valid')).value == "" || (<HTMLInputElement>document.getElementById('headhunting_profile_opening')).value == "" || (<HTMLInputElement>document.getElementById('wishlist_profile_days_valid')).value == "" || (<HTMLInputElement>document.getElementById('wishlist_profile_opening')).value == "" || (<HTMLInputElement>document.getElementById('application_profile_days_valid')).value == "" || (<HTMLInputElement>document.getElementById('application_profile_opening')).value == "") {
      alert('None of these fields cannot be empty');
      return;
    }

    //Now edit pricing details from inputs make sure that all of them are numbers
    this.pricing.vat = parseFloat((<HTMLInputElement>document.getElementById('vat')).value);
    this.pricing.grounding_fee = parseFloat((<HTMLInputElement>document.getElementById('grounding_fee')).value);
    this.pricing.monthly_fee = parseFloat((<HTMLInputElement>document.getElementById('monthly_fee')).value);
    this.pricing.per_user_monthly_fee = parseFloat((<HTMLInputElement>document.getElementById('per_user_monthly_fee')).value);
    this.pricing.per_subgroup_monthly_fee = parseFloat((<HTMLInputElement>document.getElementById('per_subgroup_monthly_fee')).value);
    this.pricing.feed.feed_publish = parseFloat((<HTMLInputElement>document.getElementById('feed_feed_publish')).value);
    this.pricing.feed.ads.price = parseFloat((<HTMLInputElement>document.getElementById('feed_feed_ad')).value);
    this.pricing.marketplace.leave.price = parseFloat((<HTMLInputElement>document.getElementById('market_place_leave')).value);
    this.pricing.marketplace.bid.price = parseFloat((<HTMLInputElement>document.getElementById('market_place_bid')).value);
    this.pricing.headhunting_profile_opening.days_valid = parseInt((<HTMLInputElement>document.getElementById('headhunting_profile_opening_days_valid')).value);
    this.pricing.headhunting_profile_opening.price = parseFloat((<HTMLInputElement>document.getElementById('headhunting_profile_opening')).value);
    this.pricing.wishlist_profile_opening.days_valid = parseInt((<HTMLInputElement>document.getElementById('wishlist_profile_days_valid')).value);
    this.pricing.wishlist_profile_opening.price = parseFloat((<HTMLInputElement>document.getElementById('wishlist_profile_opening')).value);
    this.pricing.application_profile_opening.days_valid = parseInt((<HTMLInputElement>document.getElementById('application_profile_days_valid')).value);
    this.pricing.application_profile_opening.price = parseFloat((<HTMLInputElement>document.getElementById('application_profile_opening')).value);



    this.http.put(environment.ADMIN_COMPANY_PRICING + '/' +this.routeID, this.pricing, this.httpOptions).subscribe(
      (res: any) => {
        console.log(res);
        this.isLoading = false;
        if(res.status == 200 ) {
          this.router.navigate(['/admins/admin/companies/company/company-details/' + this.routeID]);
        }
        else{

        }
      }, (err: any) => {
        console.log('error');
      }
    )

    

  }

}
